/* eslint-disable */
import axios from 'axios'
import store from '../store'
import qs from 'qs'
import router from '@/router'


const TIME_OUT_MS = 60000 // 默认请求超时时间

/*
 * @param response 返回数据列表
 */
function dictFor (dic) {
    let stt = ''
    for (var key in dic) {
        stt += dic[key] + ' '
    }
    return stt
}

/*
 * @param response 返回数据列表
 */
function handleResults (response) {
    let result = {
        success: false,
        message: '',
        data: {}
    }
    console.log('1 - 完整数据', response)
    if (response.status && response.status === 200) {
        if (response.data.code === 200) {
            result.success = true
            result.code = response.data.code
            result.message = response.data.message
            result.data = response.data.data
        } else if (response.data.code === -1000) {
            // 如果登录token失效
            store.dispatch('setToken', '')
            localStorage.setItem('token', '')
            store.dispatch('setUser', null)
            localStorage.setItem('user', null)
            // location.href = '/#/login'
            router.push({
                path: "/login"
            });
        } else {
            result.success = false
            result.code = response.data.code
            result.message = response.data.message
            result.data = response.data.data
        }
        console.log('2 - 优化数据', result)
        return result
    } else if (response.status && response.status === 500) {
        result.success = false
        result.status = response.status
        result.message = response.statusText
        return result
    } else {
        result.success = false
        result.status = response.status
        result.message = response.statusText

        let message = response.data && response.data.message ? response.data.message : ''
        if (response.data && response.data.fields) {
            message += dictFor(response.data.fields)
        }
        if (response.data && response.data.data) {
            message += ` ${response.data.data}`
        }
        if (response.data) {
            response.data.message = message
        }
        result.data = response.data ? response.data : {}
        return result
    }
}

/*
 * @param data 参数列表
 * @return
 */
function handleParams (data) {
    return data
}

export default {
    /*
     * @param url
     * @param data
     * @param response 请求成功时的回调函数
     * @param exception 异常的回调函数
     */
    post (url, data, response, exception) {
        axios({
            method: 'post',
            url: url,
            // data: qs.stringify(data),
            data: handleParams(data),
            timeout: TIME_OUT_MS,
            headers: {
                // 'Content-Type': 'application/x-www-form-urlencoded',
                'Content-Type': 'application/json; charset=UTF-8',
                'X-ADMIN-TOKEN': store.getters.getToken,
                'X-ADMIN-TYPE': store.getters.getType
            }
        }).then(
            (result) => {
                response(handleResults(result))
            }
        ).catch(
            (error) => {
                if (exception) {
                    exception(error.response)
                } else if (error.response) {
                    response(handleResults(error.response))
                } else {
                    console.log(error)
                    // response(handleResults({
                    //     status: 501,
                    //     statusText: '未知错误',
                    //     data: {message: "未知错误，请检查网络或联系管理员！"}
                    // }))
                }
            }
        )
    },
    /*
     * patch 请求
     * @param url
     * @param data
     * @param response 请求成功时的回调函数
     * @param exception 异常的回调函数
     */
    patch (url, data, response, exception) {
        axios({
            method: 'patch',
            url: url,
            data: handleParams(data),
            timeout: TIME_OUT_MS,
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'X-ADMIN-TOKEN': store.getters.getToken,
                'X-ADMIN-TYPE': store.getters.getType
            }
        }).then(
            (result) => {
                response(handleResults(result))
            }
        ).catch(
            (error) => {
                if (exception) {
                    exception(error.response)
                } else if (error.response) {
                    response(handleResults(error.response))
                } else {
                    console.log(error)
                    // response(handleResults({
                    //     status: 501,
                    //     statusText: '未知错误',
                    //     data: {message: "未知错误，请检查网络或联系管理员！"}
                    // }))
                }
            }
        )
    },
    /*
     * put 请求
     * @param url
     * @param data
     * @param response 请求成功时的回调函数
     * @param exception 异常的回调函数
     */
    put (url, data, response, exception) {
        axios({
            method: 'put',
            url: url,
            data: handleParams(data),
            timeout: TIME_OUT_MS,
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'X-ADMIN-TOKEN': store.getters.getToken,
                'X-ADMIN-TYPE': store.getters.getType
            }
        }).then(
            (result) => {
                response(handleResults(result))
            }
        ).catch(
            (error) => {
                if (exception) {
                    exception(error.response)
                } else if (error.response) {
                    response(handleResults(error.response))
                } else {
                    console.log(error)
                    // response(handleResults({
                    //     status: 501,
                    //     statusText: '未知错误',
                    //     data: {message: "未知错误，请检查网络或联系管理员！"}
                    // }))
                }
            }
        )
    },
    /*
     * put 请求
     * @param url
     * @param data
     * @param response 请求成功时的回调函数
     * @param exception 异常的回调函数
     */
    delete (url, data, response, exception) {
        axios({
            method: 'delete',
            url: url,
            data: handleParams(data),
            timeout: TIME_OUT_MS,
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'X-ADMIN-TOKEN': store.getters.getToken,
                'X-ADMIN-TYPE': store.getters.getType
            }
        }).then(
            (result) => {
                response(handleResults(result))
            }
        ).catch(
            (error) => {
                if (exception) {
                    exception(error.response)
                } else if (error.response) {
                    response(handleResults(error.response))
                } else {
                    console.log(error)
                    // response(handleResults({
                    //     status: 501,
                    //     statusText: '未知错误',
                    //     data: {message: "未知错误，请检查网络或联系管理员！"}
                    // }))
                }
            }
        )
    },
    /*
     * get 请求
     * @param url
     * @param response 请求成功时的回调函数
     * @param exception 异常的回调函数
     */
    get (url, params, response, exception) {
        axios({
            method: 'get',
            url: url,
            params: params,
            timeout: TIME_OUT_MS,
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'X-ADMIN-TOKEN': store.getters.getToken,
                'X-ADMIN-TYPE': store.getters.getType
            }
        }).then(
            (result) => {
                response(handleResults(result))
            }
        ).catch(
            (error) => {
                console.log(error)
                if (exception) {
                    exception(error.response)
                } else if (error.response) {
                    response(handleResults(error.response))
                } else {
                    console.log(error)
                    // response(handleResults({
                    //     status: 501,
                    //     statusText: '未知错误',
                    //     data: {message: "未知错误，请检查网络或联系管理员！"}
                    // }))
                }
            }
        )
    },
    /*
     * 导入文件
     * @param url
     * @param data
     * @param response 请求成功时的回调函数
     * @param exception 异常的回调函数
     */
    uploadFile (url, data, response, exception) {
        axios({
            method: 'post',
            url: url,
            data: handleParams(data),
            dataType: 'json',
            processData: false,
            contentType: false
        }).then(
            (result) => {
                response(handleResults(result, data))
            }
        ).catch(
            (error) => {
                if (exception) {
                    exception(error.response)
                } else if (error.response) {
                    response(handleResults(error.response))
                } else {
                    console.log(error)
                    // response(handleResults({
                    //     status: 501,
                    //     statusText: '未知错误',
                    //     data: {message: "未知错误，请检查网络或联系管理员！"}
                    // }))
                }
            }
        )
    },
    /*
     * 下载文件用，导出 Excel 表格可以用这个方法
     * @param url
     * @param param
     * @param fileName 如果是导出 Excel 表格文件名后缀最好用.xls 而不是.xlsx，否则文件可能会因为格式错误导致无法打开
     * @param exception 异常的回调函数
     */
    downloadFile (url, data, fileName, response, exception, options) {
        axios({
            method: 'post',
            url: url,
            data: handleParams(data),
            responseType: 'blob',
            headers: {
                'X-ADMIN-TOKEN': store.getters.getToken,
                'X-ADMIN-TYPE': store.getters.getType
            }
        }).then(
            (result) => {
                console.log(result)
                const excelBlob = result.data
                if (options && options.useHeadersFileName) {
                    fileName = decodeURIComponent(result.headers['content-disposition'].substring(20))
                }

                if ('msSaveOrOpenBlob' in navigator) {
                    // Microsoft Edge and Microsoft Internet Explorer 10-11
                    window.navigator.msSaveOrOpenBlob(excelBlob, fileName)
                } else {
                    const elink = document.createElement('a')
                    elink.download = fileName
                    elink.style.display = 'none'
                    const blob = new Blob([excelBlob])
                    elink.href = URL.createObjectURL(blob)
                    document.body.appendChild(elink)
                    elink.click()
                    document.body.removeChild(elink)
                }
            }
        ).catch(
            (error) => {
                if (exception) {
                    exception(error.response)
                } else if (error.response) {
                    response(handleResults(error.response))
                } else {
                    console.log(error)
                    // response(handleResults({
                    //     status: 501,
                    //     statusText: '未知错误',
                    //     data: {message: "未知错误，请检查网络或联系管理员！"}
                    // }))
                }
            }
        )
    },
    getDownloadFile (url, data, fileName, response, exception, options = {}) {
        axios({
            method: 'get',
            url: url,
            data: handleParams(data),
            params: options.params,
            responseType: 'blob',
            headers: {
                'X-ADMIN-TOKEN': store.getters.getToken,
                'X-ADMIN-TYPE': store.getters.getType
            }
        }).then(
            (result) => {
                console.log('result', result)
                const excelBlob = result.data
                if (options && options.useHeadersFileName) {
                    fileName = decodeURIComponent(result.headers['content-disposition'].substring(20))
                }

                if ('msSaveOrOpenBlob' in navigator) {
                    // Microsoft Edge and Microsoft Internet Explorer 10-11
                    window.navigator.msSaveOrOpenBlob(excelBlob, fileName)
                } else {
                    const elink = document.createElement('a')
                    elink.download = fileName
                    elink.style.display = 'none'
                    const blob = new Blob([excelBlob])
                    elink.href = URL.createObjectURL(blob)
                    document.body.appendChild(elink)
                    elink.click()
                    document.body.removeChild(elink)
                }
            }
        ).catch(
            (error) => {
                if (exception) {
                    exception(error.response)
                } else if (error.response) {
                    response(handleResults(error.response))
                } else {
                    console.log(error)
                    // response(handleResults({
                    //     status: 501,
                    //     statusText: '未知错误',
                    //     data: {message: "未知错误，请检查网络或联系管理员！"}
                    // }))
                }
            }
        )
    },
    uploadFileFormData (url, data, response, exception) {
        axios({
            method: 'post',
            url: url,
            data: data,
            timeout: TIME_OUT_MS,
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(
            (result) => {
                response(handleResults(result))
            }
        ).catch(
            (error) => {
                if (exception) {
                    exception(error.response)
                } else if (error.response) {
                    response(handleResults(error.response))
                } else {
                    console.log(error)
                    // response(handleResults({
                    //     status: 501,
                    //     statusText: '未知错误',
                    //     data: {message: "未知错误，请检查网络或联系管理员！"}
                    // }))
                }
            }
        )
    }
}